import { AfterViewInit, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { baseSharedActions, baseSharedSelectors } from '../../../_store';
import { SharedState } from '../../../_store/reducers/base-shared.reducer';
import { BaseLanguageSwitchColors } from '../../enums/base-language-switch-colors.enum';
import { BaseLanguage } from '../../enums/base-language.enum';
import { BASE_ROLES } from '../../../core/constants/base-roles';
import { businessTag } from '../../enums/base-application.enum';
import { BaseRolesService } from '../../../core/services/base-roles.service';

@Component({
  selector: 'base-language-switch',
  templateUrl: './base-language-switch.component.html',
})
export class BaseLanguageSwitchComponent implements AfterViewInit {
  @ViewChild('dropdownMenu') dropdownMenu!: ElementRef;
  @Input() color: BaseLanguageSwitchColors = BaseLanguageSwitchColors.darkBlue;
  @Input() isDisplayedInSidebar: boolean = false;
  @Input() shouldReloadTranslations: boolean = false;
  languages = BaseLanguage;
  isOpen = false;
  openUpward = false;
  activeLanguage: string = BaseLanguage.de;

  constructor(
    private readonly store: Store<SharedState>,
    private translateService: TranslateService,
    private roleService: BaseRolesService
  ) {
    this.store.select(baseSharedSelectors.getCurrentLanguage).subscribe((value) => {
      this.activeLanguage = value;
      this.translateService.use(value);
    });
  }

  @HostListener('window:resize')
  onResize(): void {
    if (this.isOpen) {
      this.adjustDropdownPosition();
    }
  }

  ngAfterViewInit() {
    if (this.isOpen) {
      this.adjustDropdownPosition();
    }
  }

  setLanguage(language: string) {
    this.store.dispatch(baseSharedActions.setLanguage({ language }));

    if (this.shouldReloadTranslations) {
      this.reloadTranslatedItems();
    }
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      setTimeout(() => this.adjustDropdownPosition(), 0);
    }
  }

  close(): void {
    this.isOpen = false;
  }

  private adjustDropdownPosition(): void {
    if (this.dropdownMenu) {
      const rect = this.dropdownMenu.nativeElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const dropdownHeight = this.dropdownMenu.nativeElement.offsetHeight;
      this.openUpward = rect.bottom + dropdownHeight > viewportHeight && rect.top > dropdownHeight;
    }
  }

  private reloadTranslatedItems(): void {
    /*
    Currently only requirement categories are translated on backend
    They should be reloaded with a correct language key when user is logged-in and change the language
    If some other items should be translated in the future, they can be added here
    */
    this.store.dispatch(
      baseSharedActions.getRequirements({
        application: this.roleService.hasRole(BASE_ROLES.BUSINESS_USER) ? businessTag : undefined,
      })
    );
  }
}
